"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryUseCase = void 0;
const phased_use_case_1 = require("../use-cases/phased-use-case");
class QueryUseCase extends phased_use_case_1.PhasedUseCase {
    _transform(_input, _loaded) {
        return { success: true, result: null };
    }
    async execute(input) {
        const loadResult = await this._runPhase('load', input, () => this._load(input));
        if (!loadResult.success) {
            return loadResult;
        }
        const transformResult = await this._runPhase('transform', loadResult, () => this._transform(input, loadResult.result));
        if (!transformResult.success) {
            return transformResult;
        }
        const output = await this._runPhase('present', transformResult, () => this._present(input, loadResult.result, transformResult.result));
        return { success: true, result: output };
    }
}
exports.QueryUseCase = QueryUseCase;
